"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('checkerboard', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M4 4H17H31H44V17V31V44H31H17H4V31V17V4Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17C13 14.7909 14.7909 13 17 13C19.2091 13 21 14.7909 21 17Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M35 31C35 33.2091 33.2091 35 31 35C28.7909 35 27 33.2091 27 31C27 28.7909 28.7909 27 31 27C33.2091 27 35 28.7909 35 31Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M17 4H4V17M17 4V13M17 4H31M17 13C14.7909 13 13 14.7909 13 17M17 13C19.2091 13 21 14.7909 21 17M4 17H13M4 17V31M13 17C13 19.2091 14.7909 21 17 21M17 21V44M17 21C19.2091 21 21 19.2091 21 17M17 44H4V31M17 44H31M31 27V4M31 27C28.7909 27 27 28.7909 27 31M31 27C33.2091 27 35 28.7909 35 31M31 4H44V17M31 35V44M31 35C33.2091 35 35 33.2091 35 31M31 35C28.7909 35 27 33.2091 27 31M31 44H44V31M35 31H44M44 31V17M27 31H4M21 17H44",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;